var $d7a71e78c819f0de$exports = {};
$d7a71e78c819f0de$exports = {
    "more": `Vi\u{161}e stavki`
};


export {$d7a71e78c819f0de$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
